"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCheckoutSubmit = void 0;
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const CheckoutContext_1 = require("./CheckoutContext");
const lib_1 = require("../lib");
function useCheckoutSubmit() {
    const { t } = (0, app_1.useTranslation)();
    const [createOrder] = (0, app_1.useMutation)('createOrder', {
        refetchQueries: ['getOrders'],
    });
    const { data: cart, clearCart, itemsType } = (0, lib_1.useCart)();
    const { appliedCoupons } = (0, CheckoutContext_1.useCheckout)();
    return (checkoutContext) => (data) => __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f;
        const { shippingInfo, billingInfo, guestEmail, remarks, shipping, paymentMethod, different_address, pickupPoint, } = data;
        const shippingMethod = (_a = checkoutContext.shippingMethods) === null || _a === void 0 ? void 0 : _a.find((method) => method.id === shipping);
        const paymentOnDelivery = paymentMethod === 'ON_DELIVERY';
        const allDigital = itemsType === 'DIGITAL';
        if ((!allDigital && !shippingMethod) ||
            (paymentOnDelivery && !(shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.price))) {
            throw new Error(t('error.unknown'));
        }
        const shippingExtraPrice = !allDigital && paymentOnDelivery
            ? (_c = (_b = shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.onDeliveryPrice) === null || _b === void 0 ? void 0 : _b.amount) !== null && _c !== void 0 ? _c : 0
            : 0;
        const companyData = {
            companyName: shippingInfo.companyName,
            taxNumber: shippingInfo.taxNumber,
            regon: shippingInfo.regon,
        };
        try {
            const path = yield createOrder(Object.assign(Object.assign(Object.assign({ paymentMethod, shippingAddress: Object.assign({ address: shippingInfo.address, address2: shippingInfo.addressLine2, city: shippingInfo.city, country: shippingInfo.country, firstName: shippingInfo.firstName, lastName: shippingInfo.lastName, postalCode: shippingInfo.postal_code, state: shippingInfo.voivodeship }, (!different_address && companyData)), coupons: (_d = appliedCoupons === null || appliedCoupons === void 0 ? void 0 : appliedCoupons.map((coupon) => coupon.code)) !== null && _d !== void 0 ? _d : [] }, (different_address
                ? {
                    billingAddress: Object.assign({ address: billingInfo.billingAddress, address2: billingInfo.billingAddressLine2, city: billingInfo.billingCity, country: billingInfo.billingCountry, firstName: billingInfo.billingFirstName, lastName: billingInfo.billingLastName, postalCode: billingInfo.billingPostalCode, state: billingInfo.billingState }, companyData),
                }
                : {})), (!allDigital &&
                shippingMethod && {
                shipping: {
                    id: shipping,
                    price: shippingMethod.price.amount + shippingExtraPrice,
                    pickupPoint,
                },
            })), { name: `${shippingInfo.firstName} ${shippingInfo.lastName}`, email: guestEmail, phone: shippingInfo.phone, invoice: shippingInfo.invoice, remarks, cartProducts: [
                    ...((_e = cart.products.map((product) => {
                        var _a;
                        return ({
                            id: product.id,
                            price: (_a = product.price) !== null && _a !== void 0 ? _a : 0,
                            quantity: product.quantity,
                            type: 'PRODUCT',
                            physical: product.physical,
                        });
                    })) !== null && _e !== void 0 ? _e : []),
                    ...((_f = cart.vouchers.map((voucher) => {
                        var _a;
                        return ({
                            id: voucher.id,
                            price: (_a = voucher.value) !== null && _a !== void 0 ? _a : 0,
                            quantity: voucher.quantity,
                            type: 'VOUCHER',
                            dedication: voucher.dedication,
                            physical: voucher.physical,
                            serviceId: voucher.serviceId,
                        });
                    })) !== null && _f !== void 0 ? _f : []),
                ] }));
            if (path) {
                void clearCart();
                window.location.replace(path);
                return ui_1.SubmitState.KEEP_LOADING;
            }
        }
        catch (error) {
            if ((error === null || error === void 0 ? void 0 : error.message) === 'OUT_OF_STOCK') {
            }
            ui_1.toast.error(t('error.tryAgainLater'));
            console.error(error);
            return ui_1.SubmitState.DO_NOT_CLEAR;
        }
    });
}
exports.useCheckoutSubmit = useCheckoutSubmit;
